// extracted by mini-css-extract-plugin
export default {"modal":"HowInvitesWorkModal_modal__vFlPL","body":"HowInvitesWorkModal_body__cdRV8","section":"HowInvitesWorkModal_section__-Tku6"};